import React, {useRef, useState, useEffect} from 'react';
import AreaTitle from '../../../../components/areaTitle/AreaTitle';
import DateRangeHeader from '../../../../components/dateRangeHeader/DateRangeHeader';
import { DataProviderInstance } from '../../../../api/DataProvider';
import FilterList from '../../filters/FilterList';
import ListItem from './list/ListItem';
import styles from './Appointments.module.css';
import Loading from '../../../../components/loading/Loading';
import AppointmentsState from '../../../../consts/AppointmentsState';
import { appointmentProcedureIds, procedureLabels as joinProcedureLabels } from '../../../appointments/v2/utils/appointmentUtils';

const Appointments = () => {

    const { CompanyConfig, GetResourceById, GetReportsAppointments, GetPatientById } = DataProviderInstance();

    const usingStatesSource = AppointmentsState.Filters;
    const [filtersByState, setFiltersByState] = useState(usingStatesSource.map((item, index) => index));
    const [filtersByResource, setFiltersByResource] = useState([]);
    const [filtersByProcedure, setFiltersByProcedure] = useState([]);

    const activeResources = CompanyConfig?.Resources?.filter(r => r.Active == 1) || [];
    const activeProcedures = CompanyConfig?.Procedures?.filter(p => p.Active == 1) || [];
    const resourceLabels = activeResources.map(r => r.Label);
    const procedureLabels = activeProcedures.map(p => p.Label);

    const [list, setList] = React.useState([]);
    const [filtered, setFiltered] = React.useState([]);
    const [isLoading, setIsLoading] = React.useState(false);	
    const [startDate, setStartDate] = React.useState(null);
    const [endDate, setEndDate] = React.useState(null);
    const filterRef = useRef(null);
    
    function formatDate(date) {
        if (!date) return '';
        const [year, month, day] = date.split('-');
        return `${day}/${month}/${year}`;
    }
    
    useEffect(() => {
        GetFilteredList();
    }, [filtersByState, filtersByResource, filtersByProcedure]);

    useEffect(() => {
        GetFilteredList();
    }, [list]);


    const handleDateChange = (initialDate, endDate) => {
        setStartDate(initialDate);
        setEndDate(endDate);
        loadData(initialDate, endDate);
    }

    const loadData = (initialDate, endDate) => {
        setIsLoading(true);
        GetReportsAppointments(initialDate, endDate, (response) => {
            setList(response.data);
            setIsLoading(false);

        } );
    }

    function onFilterByAppointmentsStatusChangeHandler(filters) {
        setFiltersByState(filters);
      }

    const GetFilteredList = () => {
        let filteredList = [...list];

        // Filter By Status
        filteredList = filteredList.filter((item) => filtersByState.includes(usingStatesSource.indexOf(item.status)));

        // Filtro por resource (se filtersByResource não estiver vazio)
        if (filtersByResource.length > 0 && filtersByResource.length < resourceLabels.length) {
            filteredList = filteredList.filter((item) => {
                const resourceIdx = activeResources.findIndex(r => r.Id == item.resource);
                return filtersByResource.includes(resourceIdx);
            });
        }

        // Filtro por procedure (se filtersByProcedure não estiver vazio)
        if (filtersByProcedure.length > 0 && filtersByProcedure.length < procedureLabels.length) {
            // Vários procedimentos por atendimento: entra se qualquer um estiver no filtro
            filteredList = filteredList.filter((item) => appointmentProcedureIds(item).some((id) => {
                const procedureIdx = activeProcedures.findIndex(p => String(p.Id) === id);
                return filtersByProcedure.includes(procedureIdx);
            }));
        }

        setFiltered(filteredList);
    }

    function renderItem(item, index) {
        const patientData = GetPatientById(item.patient);
        const resource = GetResourceById(item.resource).Label;
        const procedure = joinProcedureLabels(item, CompanyConfig?.Procedures) || '';
        const status = AppointmentsState.GetLabel(item.status);

        return (
            <ListItem key={index} id={item.id} date={item.date} name={patientData.name} resource={resource} procedure={procedure} status={status}/>
        );
    }

    const filtersStates = usingStatesSource.map((item) => AppointmentsState.GetLabel(item));

    return (
        <div className={styles.mainContainer}>
            <AreaTitle Title="Atendimentos" />
            <DateRangeHeader onChange={handleDateChange} />
            <div className={styles.filtersWrapper}>
                <FilterList ref={filterRef} id="reportsAppointments" label="Situação" filters={filtersStates} onChange={onFilterByAppointmentsStatusChangeHandler} initOpened={true}/>
                {resourceLabels.length > 0 && (
                    <FilterList
                        key={`res-${resourceLabels.length}`}
                        id="reportsAppointmentsResources"
                        label="Profissional"
                        filters={resourceLabels}
                        onChange={(items) => setFiltersByResource(items)}
                        initOpened={true}
                        defaultChecked={resourceLabels.map((_, i) => i)}
                    />
                )}
                {procedureLabels.length > 0 && (
                    <FilterList
                        key={`proc-${procedureLabels.length}`}
                        id="reportsAppointmentsProcedures"
                        label="Procedimento"
                        filters={procedureLabels}
                        onChange={(items) => setFiltersByProcedure(items)}
                        initOpened={true}
                        defaultChecked={procedureLabels.map((_, i) => i)}
                    />
                )}
            </div>
            {isLoading && <Loading />}
            <div className={styles.containerResume}>
            <AreaTitle Title="Resultado" Description={`<b>${filtered.length} agendamento(s)</b> encontrado(s) no período de <b>${formatDate(startDate)} à ${formatDate(endDate)}</b>.`}/>
            </div>
            <div className={styles.containerTable}>
             <table className={styles.table}>
                <thead>
                    <tr>
                        <th>Data</th>
                        <th>Hora</th>
                        <th>Situação</th>
                        <th>Paciente</th>
                        <th>Profissional</th>
                        <th>Procedimento</th>
                    </tr>
                </thead>
                <tbody>
                    {filtered && filtered.map((item, index) => (
                       renderItem(item, index)
                    ))}
                </tbody>
            </table>
            </div>
        </div>
    );
};

export default Appointments;